export default "__VITE_ASSET__CSahACn8__"